import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const EmptyItemContainer = styled.div`
  display: flex;
  width: 100%;
  color: ${({ theme }) => theme.colors[600]};
  padding: 0.5rem;
  font-style: italic;
`;

export const DropdownIconContainer = styled.div<{ isOpen: boolean }>`
  svg {
    transition: transform 0.2s;
    transform: rotate(${({ isOpen }) => (isOpen ? -180 : 0)}deg);
  }
`;
